import React from 'react';
import { motion } from 'framer-motion';
import { Lock, ArrowRight } from 'lucide-react';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 lg:py-32 bg-brand-900 text-white relative overflow-hidden" data-id="element-56">
      <div className="absolute -top-40 -left-40 w-[500px] h-[500px] bg-brand-700/30 rounded-full blur-3xl pointer-events-none" data-id="element-57"></div>
      <div className="absolute -bottom-40 -right-40 w-[500px] h-[500px] bg-brand-800/40 rounded-full blur-3xl pointer-events-none" data-id="element-58"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-60">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-800/50 text-accent-300 font-medium text-xs uppercase tracking-widest mb-8 border border-brand-700/50" data-id="element-61">
            Decisión final
          </div>

          <h2 className="text-4xl md:text-6xl font-serif font-medium mb-10 leading-[1.1] tracking-tight" data-id="element-62">
            El próximo domingo,{' '}
            <span className="text-accent-400 italic" data-id="element-63">¿qué elegís?</span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-brand-100/80 mb-14 leading-relaxed font-light" data-id="element-64">
            <p data-id="element-65">Podés seguir armando clases a último momento...</p>
            <p className="font-serif font-medium text-accent-300 text-2xl md:text-3xl" data-id="element-66">
              O podés tener todo tu año de Yoga resuelto.
            </p>
            <p className="font-medium text-white text-xl md:text-2xl pt-4" data-id="element-67">
              Dejá de improvisar.
            </p>
          </div>

          <button onClick={scrollToPricing} className="group w-full sm:w-auto bg-brand-700 hover:bg-brand-800 text-white text-lg font-medium py-5 px-10 rounded-full shadow-md hover:shadow-lg transition-all transform hover:-translate-y-0.5 mb-8 inline-flex items-center justify-center gap-3 tracking-wide" data-id="element-68">
            QUIERO MI MEGA PACK AHORA
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-69" />
          </button>

          <div className="flex items-center justify-center gap-2 text-sm text-brand-200/60 font-light" data-id="element-70">
            <Lock className="w-4 h-4" strokeWidth={1.5} data-id="element-71" />
            Pago 100% seguro · Mercado Pago · Tarjeta · Transferencia
          </div>
        </motion.div>
      </div>
    </section>;
}